import { render, staticRenderFns } from "./bodyCenterBottom.vue?vue&type=template&id=5a5b2872&scoped=true"
import script from "./bodyCenterBottom.vue?vue&type=script&lang=js"
export * from "./bodyCenterBottom.vue?vue&type=script&lang=js"
import style0 from "./bodyCenterBottom.vue?vue&type=style&index=0&id=5a5b2872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b2872",
  null
  
)

export default component.exports